import React from "react"
import { Preloader } from "../../Preloader/preloader"
import { ConfirmCode } from "../../ConfirmCode/ConfirmCode"
import { Counter } from "../../Counter/Counter"
import { getSecretCode, queryEmailChange } from "../../../user"
import "../Popup.css"
import { $SiteColors } from "../../../config/company-atts"

interface IEmailChangePopup {
  openChangeEmailPopup: boolean,
  setOpenChangeEmailPopup: React.Dispatch<React.SetStateAction<boolean>>,
  user: {
    email: string
  }
}

export const EmailChangePopup: React.FC<IEmailChangePopup> = ({ openChangeEmailPopup, setOpenChangeEmailPopup, user }) => {
  const [isValid, setIsValid] = React.useState(false)
  const [showLoader, setShowLoader] = React.useState(false)
  const [showLoaderCode, setShowLoaderCode] = React.useState(false)
  const [disableInputs, setDisabledInputs] = React.useState(false)
  const [emailStatus, setEmailStatus] = React.useState("")
  const [codeStatus, setCodeStatus] = React.useState("")
  const [value, setValue] = React.useState("")
  const [showConfirm, setShowConfirm] = React.useState(false)
  const [confirmValue, setConfirmValue] = React.useState("")
  const [buttonText, setButtonText] = React.useState("Отправить код на Email")
  const [showCounter, setShowCounter] = React.useState(false)
  const [time, setTime] = React.useState(60)

  const overlay = React.useRef<HTMLDivElement>(null);
  const form = React.useRef<HTMLFormElement>(null);

  React.useEffect(() => {
    window.addEventListener("keyup", handleEscClose, false)
    //document.addEventListener("click", overlayClickClose, false)
    return () => {
      window.removeEventListener("keyup", handleEscClose)
      //document.removeEventListener("click", overlayClickClose)
    }
  }, [disableInputs])

  React.useEffect(() => {
    setValue(user.email || value)
  }, [openChangeEmailPopup])

  React.useEffect(() => {
    if (form.current && !showLoader) setIsValid(form.current.checkValidity())
    if (!value) setIsValid(false)
  }, [value])

  React.useEffect(() => {
    if (time <= 0) {
      setShowCounter(false)
      setTime(60)
      setButtonText("Отправить код повторно")
      setDisabledInputs(false)
      setIsValid(true)
    }
  }, [time])

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target
    const value = target.value
    setValue(value)
  }

  function handleCloseChangePopup() {
    //if (!disableInputs) {
      setIsValid(false)
      setEmailStatus("")
      setCodeStatus("")
      setOpenChangeEmailPopup(false)
    //}
  }

  function handleEscClose(event: KeyboardEvent) {
    if (event.key === "Escape") {
      handleCloseChangePopup()
    }
  }

  function overlayClickClose(event: Event) {
    if (overlay.current && overlay.current === event.target) {
      handleCloseChangePopup()
    }
  }

  function handleFormSubmitEmail(event: React.FormEvent) {
    event.preventDefault()
    if (value === user.email) {
      setEmailStatus("emailSame")
      return
    } else {
      setEmailStatus("")
      setDisabledInputs(true)
      setIsValid(false)
      setShowLoader(true)

      getSecretCode(value)
        .then(res => {
          if (res.successflag) {
            setShowLoader(false)
            setShowCounter(true)
            setShowConfirm(true)
          } else throw new Error()
        })
        .catch(() => {
          setEmailStatus("emailError")
          setDisabledInputs(false)
          setIsValid(true)
          setShowLoader(false)
        })
    }
  }

  function handleFormSubmitCode(event: React.FormEvent) {
    event.preventDefault()
    setShowLoaderCode(true)
    const sendDataEmail = {
      email: value,
      code: confirmValue,
    }
    queryEmailChange(sendDataEmail)
      .then(() => {
        setCodeStatus("codeSuccess")
        setShowLoaderCode(false)
        setTimeout(handleCloseChangePopup, 3000)
      })
      .catch(() => {
        setCodeStatus("codeError")
        setShowLoaderCode(false)
      })
  }

  return (
    <div className={openChangeEmailPopup ? "popup popup_opened" : "popup"} ref={overlay}>
      <div className="popup__container">
        <h3 className="popup__title">Смена Email</h3>
        <button
          className="popup__close"
          type="button"
          onClick={handleCloseChangePopup}
          //disabled={disableInputs}
        >
          +
        </button>
        <form
          className="popup__form"
          ref={form}
          onSubmit={handleFormSubmitEmail}
        >
          <input
            type="email"
            className="popup__input popup__input_user"
            placeholder="Введите новый email"
            name="email"
            required
            title="Обязательное для заполнения поле"
            onChange={handleChange}
            disabled={disableInputs}
            value={value}
            pattern="^([a-zA-Z0-9_.+-]){1,}@([a-zA-Z0-9-]){1,}\.([a-zA-Z0-9-.]){1,}$"
          ></input>
          {emailStatus === "emailSuccess" && (
            <p className="popup__status">Код отправлен, проверьте ваш Email</p>
          )}
          {emailStatus === "emailError" && (
            <p className="popup__status popup__status_error">
              Что-то пошло не так. Попробуйте позже
            </p>
          )}
          {emailStatus === "emailSame" && (
            <p className="popup__status popup__status_error">
              Указан действующий Email
            </p>
          )}
          <button type="submit" className="popup__button" disabled={!isValid} style={{backgroundColor:$SiteColors.getState().backBtnSubmit}}>
            {showLoader && <Preloader small />}
            {showCounter && <Counter time={time} setTime={setTime} />}
            {!showLoader && !showCounter && buttonText}
          </button>
        </form>
        <form
          className={
            showConfirm
              ? "form__confirm-container form__confirm-container_open"
              : "form__confirm-container"
          }
          onSubmit={handleFormSubmitCode}
        >
          <p className="popup__confirm-text">
            Введите код подтверждения, отправленный Вам на Email
          </p>
          <ConfirmCode setConfirmValue={setConfirmValue} length={4} />
          {codeStatus === "codeSuccess" && (
            <p className="popup__status">Email успешно изменён</p>
          )}
          {codeStatus === "codeError" && (
            <p className="popup__status popup__status_error">
              Что-то пошло не так. Попробуйте позже
            </p>
          )}
          <button
            type="submit"
            className="popup__button"
            disabled={
              !showLoaderCode && confirmValue.length === 4 ? false : true
            }
          >
            {showLoaderCode && <Preloader small />}
            {!showLoaderCode && "Изменить Email"}
          </button>
        </form>
      </div>
    </div>
  )
}
